import React, { useEffect, useMemo, useState } from "react";
import "../Styles/BlueLink.css";
import logo from "../Photos/logo.png";
import apple from "../Photos/apple.png";
import android from "../Photos/android.png";
import screenshot1 from "../Photos/newUI1.png";
import screenshot2 from "../Photos/newUI2.png";
import screenshot3 from "../Photos/newUI3.png";
import screenshot4 from "../Photos/newUI4.png";
import screenshot5 from "../Photos/newUI5.png";
import screenshot6 from "../Photos/newUI6.png";
import screenshot7 from "../Photos/newUI7.png";
import screenshot8 from "../Photos/newUI8.png";

import { db } from "../bluelink";
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  onSnapshot,
  collection,
  addDoc,
  query,
  orderBy,
} from "firebase/firestore";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const screenshots = [screenshot1, screenshot2, screenshot3, screenshot4, screenshot5, screenshot6, screenshot7, screenshot8];

export default function LandingPage() {
  const [likes, setLikes] = useState(0);
  const [entries, setEntries] = useState([]);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  const likesDocRef = useMemo(() => doc(db, "blueLikes", "counter"), []);
  const messagesRef = useMemo(() => collection(db, "blueSupport"), []);

  useEffect(() => {
    const unsubLikes = onSnapshot(likesDocRef, (docSnap) => {
      if (docSnap.exists()) {
        setLikes(docSnap.data().count || 0);
      }
    });

    const q = query(messagesRef, orderBy("timestamp", "desc"));
    const unsubMsgs = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => doc.data());
      setEntries(msgs);
    });

    return () => {
      unsubLikes();
      unsubMsgs();
    };
  }, [likesDocRef, messagesRef]);

  const handleLike = async () => {
    if (localStorage.getItem("bluelink-liked")) {
      alert("You’ve already liked this!");
      return;
    }

    const docSnap = await getDoc(likesDocRef);
    if (docSnap.exists()) {
      await updateDoc(likesDocRef, {
        count: docSnap.data().count + 1,
      });
    } else {
      await setDoc(likesDocRef, { count: 1 });
    }

    localStorage.setItem("bluelink-liked", "true");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (localStorage.getItem("bluelink-feedback")) {
      alert("Thanks! You’ve already left a message.");
      return;
    }

    if (message.trim() === "") return;

    await addDoc(messagesRef, {
      name: name.trim() || "Anonymous",
      message: message.trim(),
      timestamp: new Date(),
    });

    localStorage.setItem("bluelink-feedback", "true");

    setName("");
    setMessage("");
  };

  const settings = {
    centerMode: true,
    centerPadding: "40px",
    slidesToShow: 1,
    infinite: true,
    speed: 500,
    dots: true,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "bluelink-carousel",
    beforeChange: (current, next) => setCenterIndex(next),
  };

  const [centerIndex, setCenterIndex] = useState(0);

  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-arrow right" onClick={onClick}>
        ▶
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div className="custom-arrow left" onClick={onClick}>
        ◀
      </div>
    );
  }

  return (
    <div className="landing-page">
      <img src={logo} alt="BlueLink Logo" className="landing-logo" />
      <h1 className="landing-title">
        Project BlueLink<span className="blinking-cursor">|</span>
      </h1>

      <div className="landing-card">
        <p>Coming to:</p>
        <div className="landing-platforms">
          <img src={apple} alt="Apple" className="icon" />
          <img src={android} alt="Android" className="icon" />
        </div>
        <p className="landing-release">Development on Pause.</p>
      </div>

      <p className="landing-description">
        BlueLink was a project I worked on to create a secure, minimal, and
        private way to manage connections and scheduling. The focus was on user
        control, data privacy, and simplicity. No ads, no tracking, and no
        distractions.
        <br />
        <br />
        Built using Flutter and Dart, the app was designed with Spanish support,
        2FA, and passwordless login, with plans to include passkey and biometric
        support at launch. The idea was to cater to a niche group of people,
        with a design that was mindful of colorblindness and ADHD. I wanted to
        keep things simple and easy to navigate, targeting users who are always
        on the go.
        <br />
        <br />
        BlueLink was going to be a client/provider model: the app would be free
        for clients to use forever, but providers would pay a premium tier of
        $5.99/month for additional features.
        <br />
        <br />
        The project was put on pause after realizing the costs associated with
        servers and databases were higher than anticipated. While the idea is
        still alive, I had to step back to reassess the sustainability of the
        infrastructure needed to support the app.
        <br />
        <br />
        Support was always appreciated, and I was grateful for coffee and energy
        drinks along the way. Thanks to anyone who visited!
      </p>

      <p className="landing-caption">Preview of the in-app interface</p>
      <div className="landing-screenshot-carousel">
        <Slider {...settings}>
          {screenshots.map((src, index) => (
            <div
              key={index}
              className={
                index === centerIndex
                  ? "carousel-img focused"
                  : "carousel-img blurred"
              }
            >
              <img src={src} alt={`Screenshot ${index + 1}`} />
            </div>
          ))}
        </Slider>
      </div>

      <div className="support-section">
        <h2 className="support-title">Show Your Support ❤️</h2>
        <form className="support-form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Name or initials (optional)"
            className="support-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <textarea
            placeholder="Leave a short message..."
            className="support-message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
          <div className="support-actions">
            <button type="submit" className="support-heart">
              ❤️ Leave a Message
            </button>
            <button
              type="button"
              className="support-heart"
              onClick={handleLike}
            >
              👍 Like ({likes})
            </button>
          </div>
        </form>
        <div className="support-entries">
          {entries.map((entry, index) => (
            <div key={index} className="support-entry">
              <strong>{entry.name}:</strong> <span>{entry.message}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
